module.exports = {"name":"ayacandas-redesign","version":"2.1.3","private":true,"dependencies":{"babel-polyfill":"^6.26.0","create-react-class":"^15.6.3","material-ui":"^0.20.1","react":"^16.2.0","react-dom":"^16.2.0","react-router-dom":"^4.2.2","react-scripts":"1.1.1","react-tabs":"^3.0.0","ts-react-json-table":"^0.1.1"},"proxy":"http://localhost:8080","scripts":{"start":"react-scripts start","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 258
// module chunks = 0